// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/infographic-page-bluebox/infographic-page-bluebox.component.scss
// module id = 500
// module chunks = 0